import { render, staticRenderFns } from "./lawsuit_case.vue?vue&type=template&id=7365a3eb&scoped=true"
import script from "./lawsuit_case.vue?vue&type=script&lang=js"
export * from "./lawsuit_case.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_case.vue?vue&type=style&index=0&id=7365a3eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7365a3eb",
  null
  
)

export default component.exports